/* Alpha Elements – Kontakt (/pages/contact): Prüfung im Browser, Hinweise je Thema und Vorauswahl per ?thema=… für Shopifys
   Kontaktformular (sections/ae-contact-form.liquid). Ist alles gültig, wird ganz normal an Shopify gesendet (kein preventDefault).
   Nach dem Absenden rendert Liquid die Erfolgsmeldung (form.posted_successfully?); die Zusammenfassung dafür liegt nur kurz
   im sessionStorage dieses Tabs und wird nach dem Anzeigen gelöscht. */
(() => {
  'use strict';
  const form = document.getElementById('kf-form');
  if (!form) return;
  const KEY = 'ae-kf-receipt';
  const fields = document.getElementById('kf-fields');
  const done = document.getElementById('kf-done');
  const el = n => form.elements[n];
  const name = el('contact[name]'), email = el('contact[email]'), order = el('contact[Bestellnummer]'),
        topic = el('contact[Thema]'), msg = el('contact[body]'), privacy = el('contact[Datenschutz]');
  if (!name || !email || !topic || !msg || !privacy) return;
  const MIN_MSG = 10;
  const EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/;

  /* each rule returns an error text, or '' when the field is fine */
  const rules = new Map([
    [name, () => name.value.trim() ? '' : 'Bitte gib deinen Namen ein.'],
    [email, () => {
      const v = email.value.trim();
      if (!v) return 'Bitte gib deine E-Mail-Adresse ein, damit wir dir antworten können.';
      return EMAIL_RE.test(v) ? '' : 'Diese E-Mail-Adresse scheint unvollständig zu sein – bitte prüf sie noch einmal (z. B. name@beispiel.at).';
    }],
    [topic, () => topic.value ? '' : 'Bitte wähl ein Thema aus.'],
    [msg, () => {
      const n = msg.value.trim().length;
      if (!n) return 'Bitte schreib uns deine Nachricht.';
      return n < MIN_MSG ? `Bitte beschreib dein Anliegen etwas genauer (mindestens ${MIN_MSG} Zeichen).` : '';
    }],
    [privacy, () => privacy.checked ? '' : 'Bitte bestätige den Hinweis zum Datenschutz – sonst dürfen wir deine Anfrage nicht bearbeiten.'],
  ]);
  const check = input => {
    const text = rules.get(input)(), f = input.closest('.fld'), err = f && f.querySelector('.err');
    if (f) f.classList.toggle('is-invalid', !!text);
    if (text) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    if (err) err.textContent = text;
    return !text;
  };
  rules.forEach((_, input) => {
    if (input.type === 'checkbox' || input.tagName === 'SELECT') { input.addEventListener('change', () => check(input)); return; }
    input.addEventListener('blur', () => { if (input.value.trim()) check(input); });
    input.addEventListener('input', () => { if (input.getAttribute('aria-invalid')) check(input); });
  });

  /* message counter */
  const count = document.getElementById('kf-msg-count');
  const max = +msg.getAttribute('maxlength') || 2000;
  const syncCount = () => { if (count) count.textContent = `${msg.value.length} / ${max} Zeichen`; };
  msg.addEventListener('input', syncCount);

  /* topic-specific hint (text comes from the „Thema“ block in the theme editor) */
  const hint = document.getElementById('kf-topic-hint');
  const topicKey = () => topic.selectedOptions[0]?.dataset.topic || '';
  const syncHint = () => {
    if (!hint) return;
    const h = topic.selectedOptions[0]?.dataset.hint || '';
    hint.innerHTML = h ? `<div class="note note--plain"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5.5M12 7.5h.01"/></svg><p>${h}</p></div>` : '';
    hint.hidden = !h;
  };
  topic.addEventListener('change', syncHint);

  /* preselect via link, e.g. /pages/contact?thema=abo#formular (also matches parts: widerruf → rueckgabe_widerruf) */
  const want = (new URLSearchParams(location.search).get('thema') || '').toLowerCase().trim();
  if (want) {
    const opts = [...topic.options].filter(o => o.dataset.topic);
    const o = opts.find(x => x.dataset.topic === want) || opts.find(x => x.dataset.topic.split('_').includes(want)) || opts.find(x => x.dataset.topic.startsWith(want));
    if (o) o.selected = true;
  }
  syncHint(); syncCount();

  form.addEventListener('submit', e => {
    const invalid = [...rules.keys()].filter(input => !check(input));
    if (invalid.length) { e.preventDefault(); invalid[0].focus(); return; }
    const v = input => (input ? input.value.trim() : '');
    const rows = [['Name', v(name)], ['E-Mail', v(email)], ['Thema', topic.value]];
    if (v(order)) rows.push(['Bestellnummer', v(order)]);
    rows.push(['Nachricht', v(msg)]);
    try { sessionStorage.setItem(KEY, JSON.stringify({ name: v(name), email: v(email), rows })); } catch (_) { /* private mode */ }
    window.AE?.track?.('contact_submit', { topic: topicKey() });
    form.querySelector('[type=submit]')?.setAttribute('aria-busy', 'true');
  });

  /* success screen (rendered by Liquid after Shopify accepted the message) */
  if (done) {
    let data = null;
    try { data = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (_) { data = null; }
    if (data && Array.isArray(data.rows)) {
      const dl = document.getElementById('kf-receipt');
      data.rows.forEach(([k, val]) => { const dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = k; dd.textContent = val; dl.append(dt, dd); });
      const first = String(data.name || '').split(/\s+/)[0];
      if (first) document.getElementById('kf-done-title').textContent = `Danke, ${first} – deine Nachricht ist angekommen.`;
      document.getElementById('kf-done-mail').textContent = data.email || '';
      document.getElementById('kf-done-plain').hidden = true;
      document.getElementById('kf-done-detail').hidden = false;
      dl.hidden = false;
    }
    done.querySelector('h3')?.focus({ preventScroll: true });
    document.getElementById('kf-again')?.addEventListener('click', () => {
      if (data) { name.value = data.name || name.value; email.value = data.email || email.value; }
      done.hidden = true;
      if (fields) fields.hidden = false;
      syncHint(); syncCount();
      topic.focus();
    });
  }
})();
